import { Job } from "@/models/Job.model";
import { FC, JSX } from "react";
import JobOverviewListItemFetcher from "./job.overview.list.item.fetcher";

interface JobOverviewListProps {
  jobs: Job[];
}

const JobOverviewList: FC<JobOverviewListProps> = ({ jobs }): JSX.Element => {
  if (jobs && jobs.length > 0) {
    return (
      <>
        {jobs.map((job) => (
          <JobOverviewListItemFetcher key={job.slug} {...job} />
        ))}
      </>
    );
  }

  return <>No jobs available</>;
};

export default JobOverviewList;
